import { injectIntl } from "react-intl";
import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const formatClicksAxis = (value) => {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}K`;
  return value.toLocaleString();
};

const formatConversionsAxis = (value) => {
  if (value >= 1_000) return `${(value / 1_000).toFixed(0)}k`;
  return value.toLocaleString();
};

const getNiceMax = (max) => {
  if (max <= 0) return 1000;
  const magnitude = 10 ** Math.floor(Math.log10(max));
  return Math.ceil(max / magnitude) * magnitude;
};

const ClickConversionTrends = ({ data = [] }) => {
  const maxClicks = getNiceMax(Math.max(...data.map((item) => item.clicks), 0));
  const maxConversions = getNiceMax(
    Math.max(...data.map((item) => item.conversions), 0)
  );

  return (
    <div className="SmsAnalyticsChartCard SmsAnalyticsChartCardWide">
      <div className="SmsAnalyticsChartHeader">
        <div className="SmsAnalyticsChartTitle">Click &amp; Conversion Trends</div>
        <div className="SmsAnalyticsChartLegend">
          <div className="SmsAnalyticsLegendItem">
            <span className="SmsAnalyticsLegendDot SmsAnalyticsLegendDotPurple" />
            Clicks
          </div>
          <div className="SmsAnalyticsLegendItem">
            <span className="SmsAnalyticsLegendDot SmsAnalyticsLegendDotBlue" />
            Conversions
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={280}>
        <ComposedChart
          data={data}
          margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="clicksGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#7E50EA" stopOpacity={0.25} />
              <stop offset="95%" stopColor="#7E50EA" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#F0F1F5" vertical={false} />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#8185A8", fontSize: 12, fontFamily: "Inter" }}
          />
          <YAxis
            yAxisId="clicks"
            axisLine={false}
            tickLine={false}
            tickFormatter={formatClicksAxis}
            tick={{ fill: "#8185A8", fontSize: 12, fontFamily: "Inter" }}
            width={50}
            domain={[0, maxClicks]}
          />
          <YAxis
            yAxisId="conversions"
            orientation="right"
            axisLine={false}
            tickLine={false}
            tickFormatter={formatConversionsAxis}
            tick={{ fill: "#8185A8", fontSize: 12, fontFamily: "Inter" }}
            width={50}
            domain={[0, maxConversions]}
          />
          <Tooltip
            formatter={(value, name) => [
              Number(value).toLocaleString(),
              name === "clicks" ? "Clicks" : "Conversions",
            ]}
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #E5E7F0",
              fontSize: 12,
              fontFamily: "Inter",
            }}
          />
          <Area
            yAxisId="clicks"
            type="monotone"
            dataKey="clicks"
            stroke="#7E50EA"
            strokeWidth={2}
            fill="url(#clicksGradient)"
            name="clicks"
          />
          <Line
            yAxisId="conversions"
            type="monotone"
            dataKey="conversions"
            stroke="#3B82F6"
            strokeWidth={2}
            dot={false}
            name="conversions"
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default injectIntl(ClickConversionTrends);
